export const navigationLinks = [
  { to: '/', label: 'Hjem' },
  { to: '/#about', label: 'Historie' },
  { to: '/#menu', label: 'Menu' },
  { to: '/#team', label: 'Mød Holdet' }
];